import { useState, useEffect } from "react";
import { Spinner } from "react-bootstrap";
import TextTransition, { presets } from "react-text-transition";
import { eAssetType } from "../../../@types/Asset";
import { genericCategories } from "../../AnalysisPageComponents/LoadingAnalysis/data/analyze-categories";
import { GiMultipleTargets, GiWorld } from "react-icons/gi";
import { projectPrimaryColor } from "../../../generalConfigs";
import { GrIndicator, GrMultiple } from "react-icons/gr";
import { RiMentalHealthFill, RiSkull2Line } from "react-icons/ri";
import { FaRegNewspaper, FaUncharted } from "react-icons/fa";
import { MdOutlinePivotTableChart } from "react-icons/md";
import { LuFileBox, LuFileLineChart } from "react-icons/lu";
import { FaMagnifyingGlassChart, FaSunPlantWilt } from "react-icons/fa6";
import { BsStoplights } from "react-icons/bs";
import { FiBarChart2, FiTarget } from "react-icons/fi";
import { HiOutlineReceiptTax } from "react-icons/hi";
import { GoGoal } from "react-icons/go";
import { SiWolframmathematica } from "react-icons/si";

interface Props {
  assetType?: eAssetType;
  show: boolean;
}
export default function LoadingQueue({ assetType, show }: Props) {
  const [index, setIndex] = useState<number>(0);
  const [spinnerColor, setSpinnerColor] = useState<string>("");
  const defaultIconSize = 32;

  const categories = [
    {
      title: "Avaliando diversificação",
      icon: <GrMultiple size={defaultIconSize} color={projectPrimaryColor} />,
    },
    {
      title: "Alocação de Ativos",
      icon: <LuFileBox size={defaultIconSize} color={projectPrimaryColor} />,
    },
    {
      title: "Impacto Fiscal e Custos",
      icon: (
        <HiOutlineReceiptTax
          size={defaultIconSize}
          color={projectPrimaryColor}
        />
      ),
    },
    {
      title: "Cenário Macroeconômico",
      icon: <GiWorld size={defaultIconSize} color={projectPrimaryColor} />,
    },
    {
      title: "Avaliando risco e retorno",
      icon: <RiSkull2Line size={defaultIconSize} color={projectPrimaryColor} />,
    },
    {
      title: "Medindo Sharpe Ratio",
      icon: <FaUncharted size={defaultIconSize} color={projectPrimaryColor} />,
    },
    {
      title: "Correlação entre Ativos",
      icon: (
        <MdOutlinePivotTableChart
          size={defaultIconSize}
          color={projectPrimaryColor}
        />
      ),
    },
    {
      title: "Análise Fundamentalista",
      icon: (
        <LuFileLineChart size={defaultIconSize} color={projectPrimaryColor} />
      ),
    },
    {
      title: "Performance Histórica",
      icon: (
        <FaMagnifyingGlassChart
          size={defaultIconSize}
          color={projectPrimaryColor}
        />
      ),
    },
    {
      title: "Analisando nível de risco",
      icon: <BsStoplights size={defaultIconSize} color={projectPrimaryColor} />,
    },
    {
      title: "Analisando projeções do mercado",
      icon: <FiTarget size={defaultIconSize} color={projectPrimaryColor} />,
    },
    {
      title: "Analisando volume de negociações",
      icon: <FiBarChart2 size={defaultIconSize} color={projectPrimaryColor} />,
    },
    {
      title: "Analisando notícias",
      icon: (
        <FaRegNewspaper size={defaultIconSize} color={projectPrimaryColor} />
      ),
    },
    {
      title: "Sentimento de outros investidores",
      icon: (
        <RiMentalHealthFill
          size={defaultIconSize}
          color={projectPrimaryColor}
        />
      ),
    },

    {
      title: "Índices de Referência",
      icon: <GrIndicator size={defaultIconSize} color={projectPrimaryColor} />,
    },
    {
      title: "Objetivos do Investidor",
      icon: <GoGoal size={defaultIconSize} color={projectPrimaryColor} />,
    },
    {
      title: "Exposição a mercados",
      icon: (
        <FaSunPlantWilt size={defaultIconSize} color={projectPrimaryColor} />
      ),
    },
    {
      title: "Modelos Quantitativos",
      icon: (
        <SiWolframmathematica
          size={defaultIconSize}
          color={projectPrimaryColor}
        />
      ),
    },
  ];

  useEffect(() => {
    setIndex(0);
  }, [assetType]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setSpinnerColor("#5af271");

      setTimeout(() => {
        setIndex((oldIndex) => oldIndex + 1);
        setSpinnerColor("");
      }, 250);
    }, 3500);
    return () => clearInterval(intervalId);
  }, []);

  if (!show) {
    return <></>;
  }

  return (
    <div className="card card-minimal-four h-100">
      <div className="card-body d-flex flex-column justify-content-center">
        <div className="text-center pd-t-30 pd-b-5">
          {categories[index % categories.length].icon}
        </div>
        <div className="d-flex justify-content-center text-center pd-l-20 pd-r-20">
          <h1>
            <TextTransition
              className="tx-light"
              text={categories[index % categories.length].title}
              springConfig={presets.wobbly}
            />
          </h1>
        </div>
        <div className="text-center pd-b-30">
          <Spinner
            style={{ marginTop: 5, color: spinnerColor }}
            animation="border"
            size="sm"
          />
        </div>
      </div>
    </div>
  );
}
